import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { distinctUntilKeyChanged } from 'rxjs/operators';

@Component({
  selector: 'app-my-coverage-reporting',
  templateUrl: './my-coverage-reporting.component.html',
  styleUrls: ['./my-coverage-reporting.component.scss'],
})
export class MyCoverageReportingComponent implements OnInit {
  public projectId: number;
  public projectName: string;
  public projectColors: string;

  constructor(private store: Store<AppState>) {
    this.projectId = null;
    this.projectName = null;
    this.projectColors = null;
  }

  ngOnInit() {
    this.store
      .select('project')
      .pipe(distinctUntilKeyChanged('projectSelected'))
      .subscribe(({ projectSelected }) => {
        if (projectSelected) {
          this.projectId = projectSelected?.value;
          this.projectName = projectSelected?.name;
          this.projectColors = projectSelected?.color;
        }
      });
  }
}
